<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>General Settings</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>

        <v-row dense class="subtitle-2 text--primary">

          <v-col cols="12" xs="12" md="6">
            <v-radio-group dense label="Select sales person when selling" v-model="record.SelectSalesPerson" row>
              <v-radio label="Yes" value="Y"></v-radio>
              <v-radio label="No" value="N"></v-radio>
            </v-radio-group>
          </v-col>

          <v-col cols="12" xs="12" md="6">
            <v-radio-group dense label="Show buying price on sales ui" v-model="record.ShowBpSalesUi" row>
              <v-radio label="Yes" value="Y"></v-radio>
              <v-radio label="No" value="N"></v-radio>
            </v-radio-group>
          </v-col>

        </v-row>

        <v-row dense class="subtitle-2 text--primary">
          <!-- cols 6 -->
          <v-col cols="12" md="6">
            <v-row dense class="subtitle-2 text--primary">
              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Sell Insufficient Stock" v-model="record.SellDeficit" row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Transfer Insufficient" v-model="record.TransferDeficit" row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Accept Stock Transfer" v-model="record.AcceptTransfer" row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Update Buying Price on Stock Transfer" v-model="record.UpdateBpTransfer"
                  row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>


              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Starting Float Mandatory" v-model="record.RequireFloat" row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="User pin when selling mandatory" v-model="record.RequirePin" row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Products Have Unit of Measure" v-model="record.ProductsHaveUom" row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Pharmacy / chemist  UI (set default)" v-model="record.PharmacyUi" row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Show Dealers In On Invoice" v-model="record.ShowDealersIn" row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Single Line Receipt" v-model="record.SingleLineReceipt" row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Imei Scanning Version" v-model="record.ImeiScanningVersion" row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Cash Back Disabled" v-model="record.CashBackDisabled" row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" xs="12" md="12"> 
                 <v-text-field type="number" v-model="record.OfflineSalesDays" outlined dense label="Maintain offline sales for (days)"></v-text-field>
              </v-col>
             
              <v-col cols="12">
                <v-autocomplete autocomplete="off" name="imeiCategory" hide-details dense outlined
                  v-model="record.ImeiCategoryId" :items="categories" label="Category" item-text="Name" item-value="id">
                </v-autocomplete>
              </v-col>

            </v-row>
          </v-col>

          <!-- cols 6 -->
          <v-col cols="12" md="6">
            <v-row dense class="subtitle-2 text--primary">
              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Sell Below The Set Lower Limit" v-model="record.SellBelowLimit" row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Print Receipt Enabled By Default" v-model="record.EnablePrinting" row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Show Available Stock By Default" v-model="record.ShowAvailableStock" row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Barcode UI" v-model="record.BarcodeUi" row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Allow Outsourced Sales Offline" v-model="record.AllowOutsourced" row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Show Buying Price on Outsourced" v-model="record.ShowBpOnOutsourced" row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Show Unit Input on Outsourced" v-model="record.ShowUnitInputOutsourced" row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Etims Integrated" v-model="record.EtimsIntegrated" row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Have Z-Report for multiple cashiers " v-model="record.MultipleZendReports"
                  row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

                <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Exports Dealer Version " v-model="record.ExportsVersion"
                  row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Assign Multiple Shops To Cashier (Backend Access) " v-model="record.MultipleCashiersBackend"
                  row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Limit Customers To Specificc Shops " v-model="record.CustomersPerShop"
                  row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>

               <v-col cols="12" xs="12" md="12">
                <v-radio-group dense label="Limit Suppliers To Specificc Shops " v-model="record.SuppliersPerShop"
                  row>
                  <v-radio label="Yes" value="Y"></v-radio>
                  <v-radio label="No" value="N"></v-radio>
                </v-radio-group>
              </v-col>



              <v-col cols="12" xs="12" md="12">
                <v-text-field v-model="record.PrinterIp" outlined dense label="Printer IP Address"></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" md="12">
                <v-text-field v-model="record.SuspendAt" outlined dense label="Suspend System At"></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" md="12">
                <v-text-field v-model="record.ActivateAt" outlined dense label="Activate System At"></v-text-field>
              </v-col>

            </v-row>
          </v-col>


          <v-col cols="12">
            <v-btn color="primary" class="float-right" @click="save" :loading="loader">
              <v-icon left>mdi-content-save</v-icon>Update Settings
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    menu2: false,
    menu1: false,
    loader: false,
    record: {},
    categories: [],
    industries: [],
    products: [],
    brands: [],
    stores: [],
    uom: [],
    taxGroups: []
  }),
  methods: {
    save() {
      const data = this.record;
      const self = this;
      self.loader = true;

      data.OfflineSalesDays = this.record.OfflineSalesDays != null && this.record.OfflineSalesDays !== 0 && this.record.OfflineSalesDays !== undefined
        ? parseInt(this.record.OfflineSalesDays)
        : 0;
      const url = "/general-settings";
      this.$store
        .dispatch("put", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            this.$refs.snackbar.show("Update successful", "green");
            self.getGenSettings();
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.record = { ...res.ResponseData };
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getCategories() {
      const self = this;
      this.$store
        .dispatch("get", `/products-categories`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.categories = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getGenSettings();
    this.getCategories();
  }
};
</script>